export interface RuntimeAccessConfig {
    disableCloudRuntime: boolean;
}

export interface RuntimeAccessOptions {
    disableCloudRuntime?: boolean;
}

export const parseDisableCloudRuntime = (value?: string | null): boolean => {
    return ['1', 'true', 'yes', 'on'].includes((value || '').trim().toLowerCase());
};

export const runtimeAccessConfig: RuntimeAccessConfig = {
    disableCloudRuntime: parseDisableCloudRuntime(import.meta.env.VITE_DISABLE_CLOUD_RUNTIME),
};

export const isCloudRuntimeDisabled = (options?: RuntimeAccessOptions): boolean => {
    return options?.disableCloudRuntime ?? runtimeAccessConfig.disableCloudRuntime;
};
